<template>
	<div class="d-flex">
		<v-autocomplete
			v-model="selectedFieldId"
			:items="columns"
			class="mx-1"
			item-text="Label"
			item-value="Id"
			label="Field"
			:rules="[validations.ruleRequired(selectedFieldId)]"
			dense
			outlined
			hide-details="auto"
		/>
		<v-select
			v-model="selectedOperator"
			:items="operators"
			class="mx-1"
			item-text="label"
			item-value="value"
			label="Operator"
			:rules="operatorRule"
			dense
			outlined
			hide-details="auto"
			:disabled="disableOperators"
		/>

		<v-text-field
			v-if="filterHasValue"
			v-model="selectedValue"
			clearable
			class="mx-1"
			:rules="valueRule"
			label="Value"
			dense
			outlined
			:disabled="disableValue"
			hide-details="auto"
		/>
		<v-text-field
			v-if="filterHasDateValue"
			v-model="dateValue"
			clearable
			class="mx-1"
			:rules="valueRule"
			label="Value"
			dense
			outlined
			:disabled="disableValue"
			hide-details="auto"
			:placeholder="dateFormat"
		>
		</v-text-field>
		<v-text-field
			v-if="filterHasDateTimeValue"
			v-model="dateTimeValue"
			clearable
			class="mx-1"
			:rules="valueRule"
			label="Value"
			dense
			outlined
			:disabled="disableValue"
			hide-details="auto"
			:placeholder="dateTimeFormat"
		>
		</v-text-field>
		<!-- <v-menu v-if="filterHasDateValue">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-if="filterHasDateValue" :value="dateTimeValue" clearable class="mx-1" 
                    label="Value" dense outlined v-bind="attrs" v-on="on" readonly :disabled="disableValue"
                    hide-details="auto" />
            </template>
            <v-date-picker v-model="dateTimeValue" @input="menu = false" no-title color="green"></v-date-picker>
        </v-menu>
         -->
		<v-select
			v-if="filterHasBooleanValue"
			label="Value"
			v-model="selectedValue"
			dense
			outlined
			:rules="valueRule"
			:items="booleanItems"
			item-text="Text"
			item-value="Id"
		/>
		<v-select
			v-if="filterHasApprovalStatusValue"
			label="Value"
			v-model="selectedValue"
			dense
			outlined
			:rules="valueRule"
			:items="approvalStatusItems"
			item-text="Text"
			item-value="Id"
		/>

		<v-btn
			v-if="index >= 0"
			color="red"
			class="mx-1"
			height="40px"
			small
			outlined
			@click="removeFilter()"
		>
			<v-icon>mdi-close</v-icon>
		</v-btn>
	</div>
</template>
<script>
import filterComponentMixin from '../../../mixins/filters/filterComponentMixin';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';
export default {
	name: 'FilterComponent',

	mixins: [projectSettingsMixin, filterComponentMixin],
	props: {
		columns: Array,
		filter: Object,
		index: Number,
	},
	data() {
		return {
			selectedFieldId: this.filter.FieldId || null,
			selectedOperator: this.filter.Operator || null,
			dateValue: null,
			dateTimeValue: null,
			selectedValue: this.filter.Value || null,
		};
	},
	methods: {
		onFilterChanged() {
			let object = {
				FieldId: this.selectedFieldId,
				Operator: this.selectedOperator,
				Value: this.selectedValue,
				IsDeleted: null,
			};
			if (this.filter.Id) object.Id = this.filter.Id;
			this.$emit('filterChanged', object, this.index);
		},

		removeFilter() {
			this.$emit('onRemoveFilter', this.index);
		},
	},
};
</script>
